'use strict'

function constructChartData() {
    let data = {};
    let priceMin = Infinity;
    let priceAvg = 0;
    let priceMax = 0;
    let carbonMin = Infinity;
    let carbonAvg = 0;
    let carbonMax = 0;
    const results = document.getElementById('results').childNodes;
    let numResults = results.length;


    for(let i = 0; i < results.length; i++) {
        let price = document.getElementById(`price-container-${i}`).innerHTML.replace(/\D/g,'');
        let carbon = document.getElementById(`carbon-container-${i}`).innerHTML;
        let carbonInLegs = document.getElementById(`result-details-${i}`).getElementsByClassName(`carbon-value`);
        let detailCarbonMissing = false;

        //checking into each leg of the trip option
        for (let j = 0; j < carbonInLegs.length; j++){
            let carbonDetailValue = carbonInLegs[j].innerText.replace(' ', ''); //carbon values in each leg
            carbonDetailValue = carbonDetailValue.substring(0, carbonDetailValue.indexOf('k')); //get numbers only
            if (isNaN(carbonDetailValue)){      //if carbon value is ?, exclude this trip option from the calculation
                numResults--; 
                //console.log("numR= " + numResults);                 //only count the trip options that have complete carbon values
                //console.log("result len = "+results.length);
                detailCarbonMissing = true;     //set flag to skip this entire trip option
                break;
            }
        }

        if (detailCarbonMissing)    //if true, continue to the next trip option
            continue;

        //get the total carbon value for this entire trip option
        carbon = carbon.substring(0, carbon.indexOf(' '));

        price = +price;   
        carbon = +carbon; //convert to number

        /*
        if (isNaN(carbon)){
            numResults--;   //exclude the ? results from calculation
            continue;
        }
        */

        // Collect min/avg/max values
        if(price < priceMin) priceMin = price;
        if(price > priceMax) priceMax = price;
        if(carbon < carbonMin) carbonMin = carbon;
        if(carbon > carbonMax) carbonMax = carbon;
        priceAvg += price;
        carbonAvg += carbon;
    }

    for (let i = 0; i < results.length; i++){
        let carbon = document.getElementById(`carbon-container-${i}`).innerHTML;
        carbon = carbon.substring(0, carbon.indexOf(' '));
        carbon = +carbon; 
        //console.log(carbon+" "+carbonMin);
        if (carbon === carbonMin){
            let yourGreenFly = document.createElement('div');
            yourGreenFly.className = 'your-green-fly';
            yourGreenFly.innerHTML = `<p>Your <b>Green</b>FLY</p>`;
            document.getElementById(`carbon-container-${i}`).appendChild(yourGreenFly);
            document.getElementById(`carbon-container-${i}`).style.color = '#27a667';   //text color
        }
    }

    priceAvg /= numResults;
    carbonAvg /= numResults;
    
    return {
        "carbonMin" : carbonMin,
        "carbonMax" : carbonMax,
        "carbonAvg" : carbonAvg,
        "range"    : Math.ceil(carbonMax/100)*100
    }
}

export default constructChartData



// WEBPACK FOOTER //
// ./calcChart.js